module.exports = __webpack_public_path__ + "media/images/new-ui-images/patient-icon-1b6bfd2037377f85d56ae67408872851.svg";